/**
 * Komal OS - Authentication Store
 * Manages user login state, tokens, and user data
 */

import { create } from 'zustand';
import api from '../services/api';

const useAuthStore = create((set) => ({
  // State
  user: null,
  token: localStorage.getItem('auth_token') || null,
  isAuthenticated: !!localStorage.getItem('auth_token'),
  isLoading: false,
  error: null,

  // Actions
  login: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      const response = await api.post('/auth/login', { email, password });
      const { token, user_id, name, role, department, department_id } = response.data;

      localStorage.setItem('auth_token', token);
      localStorage.setItem('user_id', user_id);

      set({
        token,
        user: { id: user_id, name, email, role, department, department_id },
        isAuthenticated: true,
        isLoading: false,
      });

      return true;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Login failed';
      set({ error: errorMessage, isLoading: false });
      return false;
    }
  },

  logout: () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_id');
    set({ user: null, token: null, isAuthenticated: false });
  },

  verifyToken: async () => {
    const token = localStorage.getItem('auth_token');
    if (!token) return false;

    try {
      const response = await api.post('/auth/verify-token', { token });
      const { user_id, name, email, role, department, department_id } = response.data;
      set({
        token,
        user: { id: user_id, name, email, role, department, department_id },
        isAuthenticated: true,
      });
      return true;
    } catch (error) {
      set({ token: null, isAuthenticated: false, user: null });
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_id');
      return false;
    }
  },

  setUser: (userData) => set({ user: userData }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),
}));

export default useAuthStore;
